import { render, staticRenderFns } from "./FormBuilderDataCollector.vue?vue&type=template&id=622693fc"
import script from "./FormBuilderDataCollector.vue?vue&type=script&lang=ts"
export * from "./FormBuilderDataCollector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports